<template>
<div>
  <breadcrumb :items="[{ text: 'Relatórios', active: true }]" />
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-success card-header-icon">
          <p class="card-title">Filtro por data</p>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <b-form-group label="A partir de">
                <b-input v-model="filters.startDate" type="date" name="startDate" />
                <field-error :msg="veeErrors" field="startDate" />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="Até">
                <b-input v-model="filters.endDate" type="date" name="endDate" />
                <field-error :msg="veeErrors" field="endDate" />
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <button class="btn btn-success btn-icon" @click="recalculate">
              recalcular
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-success card-header-icon">
          <p class="card-category">Valor médio dos pedidos</p>
          <h3 class="card-title">{{ averageTicket | moeda }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-success card-header-icon">
          <p class="card-category">Valor médio gasto por cliente</p>
          <h3 class="card-title">{{ averagePerClient | moeda }}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header card-header-icon card-header-rose">
      <h4 class="card-title">Maiores clientes</h4>
    </div>
    <div class="card-body">
      <div>
        <div v-if="clients && clients.length">
          <b-table stacked="lg" :fields="best_buyers_table" :items="clients.slice(0, 12)" :sort-by="'name'">
            <template slot="client" slot-scope="data">
              <router-link :to="'/usuario/' + data.value._id">
                {{ data.value.name }}
                <small><br />{{ data.value.email }}</small>
              </router-link>
            </template>

            <template slot="qtd" slot-scope="data">
              {{ data.value }} compras
            </template>
            <template slot="total" slot-scope="data">
              {{ data.value | moeda }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header card-header-icon card-header-rose">
      <h4 class="card-title">Produtos mais vendidos</h4>
    </div>
    <div class="card-body">
      <div>
        <div v-if="products && products.length">
          <b-table stacked="lg" :fields="best_sellers_table" :items="products.slice(0, 12)" :sort-by="'name'">
            <template slot="product_variation" slot-scope="data">
              <router-link :to="'/editar-variação-produto/' + data.value.id" class="product_td">
                <product-image :product="data.value" :product_variation="data.value" />
                {{ data.value.name }}
              </router-link>
            </template>

            <template slot="qtd" slot-scope="data">
              {{ data.value }} unidades
            </template>
            <template slot="total" slot-scope="data">
              {{ data.value | moeda }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from "axios";
import ProductImage from "@/components/ProductImage";
import FieldError from "@/components/FieldError";

export default {
  name: "Dashboard",

  data() {
    return {
      products: [],
      clients: [],
      averageTicket: 0,
      averagePerClient: 0,
      filters: {
        startDate: null,
        endDate: null,
      },
      date_unit: {
        Dias: "days",
        Meses: "months",
        Anos: "years",
      },
      best_buyers_table: [{
          key: "client",
          label: "Cliente",
          sortable: true,
        },
        {
          key: "qtd",
          label: "Compras",
          sortable: true,
        },
        {
          key: "total",
          label: "Valor total",
          sortable: true,
        },
      ],
      best_sellers_table: [{
          key: "product_variation",
          label: "Produto",
          sortable: true,
        },
        {
          key: "qtd",
          label: "Vendidos",
          sortable: true,
        },
        {
          key: "total",
          label: "Valor total",
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.getAverageTicket();
    this.getBestSellers();
    this.getBestBuyers();
  },
  methods: {
    recalculate() {
      this.getAverageTicket();
      this.getBestSellers();
      this.getBestBuyers();
    },
    async getAverageTicket() {
      axios
        .get("/reports/average-ticket", {
          params: {
            startDate: this.filters.startDate,
            endDate: this.filters.endDate,
          },
        })
        .then((response) => {
          this.averageTicket = response.data;
        })
        .catch(this.showError);
    },
    async getBestSellers() {
      axios
        .get("/reports/best-sellers", {
          params: {
            startDate: this.filters.startDate,
            endDate: this.filters.endDate,
          },
        })
        .then((response) => {
          this.products = response.data;
        })
        .catch(this.showError);
    },
    async getBestBuyers() {
      axios
        .get("/reports/best-buyers", {
          params: {
            startDate: this.filters.startDate,
            endDate: this.filters.endDate,
          },
        })
        .then((response) => {
          this.clients = response.data.clients;
          this.averagePerClient = response.data.averagePerClient;
        })
        .catch(this.showError);
    },
  },
  components: {
    ProductImage,
    FieldError,
  },
};
</script>

<style lang="sass" scoped>
.card-header
    a
        color: #fff
    &.card-header-image
    img
        max-height: none
</style>
